export const portfolioData = [
  {
    id: 1,
    name: "Site E_Commerce",
    languages: ["javascript", "css"],
    languagesIcons: ["fa fa-js", "fa fa-css3"],
    source: "http://www.figurinekams.netlify.app",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium, veritatis debitis odio eveniet quos incidunt eaque nemo eius perferendis consequatur? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium.",
    picture: "./media/Projet1.PNG",
  },
  {
    id: 2,
    name: "Site d'Apprentissage",
    languages: ["javascript", "react"],
    languagesIcons: ["fa fa-js", "fa fa-react"],
    source: "http://www.github.com",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium, veritatis debitis odio eveniet quos incidunt eaque nemo eius perferendis consequatur? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium.",
    picture: "./media/Projet2.PNG",  },
  {
    id: 3,
    name: "Portofolio",
    languages: ["javascript", "php", "css"],
    languagesIcons: ["fa fa-js", "fa fa-php", "fa fa-css3"],
    source: "http://www.github.com",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium, veritatis debitis odio eveniet quos incidunt eaque nemo eius perferendis consequatur? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium.",
    picture: "./media/Projet3.PNG",  },
  {
    id: 4,
    name: "SportyKam's",
    languages: ["javascript", "php", "react"],
    languagesIcons: ["fa fa-js", "fa fa-php", "fa fa-react"],
    source: "http://www.sportkams.netlify.app",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium, veritatis debitis odio eveniet quos incidunt eaque nemo eius perferendis consequatur? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium.",
    picture: "./media/Projet4.PNG",  },
  {
    id: 5,
    name: "Formulaire",
    languages: ["javascript", "css"],
    languagesIcons: ["fa fa-js", "fa fa-css3"],
    source: "http://www.github.com",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium, veritatis debitis odio eveniet quos incidunt eaque nemo eius perferendis consequatur? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium.",
    picture: "./media/Projet5.PNG",  },
  {
    id: 6,
    name: "Site complet #spike",
    languages: ["javascript", "react", "css"],
    languagesIcons: ["fa fa-js", "fa fa-react", "fa fa-css3"],
    source: "http://www.github.com",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium, veritatis debitis odio eveniet quos incidunt eaque nemo eius perferendis consequatur? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium.",
    picture: "./media/Projet6.PNG",  },
];
